import React, { useState, cloneElement, Component } from 'react';
import { motion } from 'framer-motion';
import { SparkleEffect } from '../components/SparkleEffect';
import { GlitterHeart } from '../components/GlitterHeart';
import { CalendarIcon, MessageCircleIcon, SparklesIcon, FlameIcon } from 'lucide-react';
export function CoachingPage() {
  const handleRequestSession = (tier: string) => {
    const subject = encodeURIComponent(`Coaching Request - ${tier}`);
    const body = encodeURIComponent(`Hi Mandy!\n\nI'm interested in the ${tier} coaching option.\n\nPlease reach out so we can discuss details and get started!\n\nThank you!`);
    window.location.href = `mailto:trippinwithmandy@gmail.com?subject=${subject}&body=${body}`;
  };
  return <div className="min-h-screen pt-24 pb-24 relative" data-id="element-2088" data-mp="10pomhy4ruqxr">
      {/* Full background image */}
      <img src="https://cdn.magicpatterns.com/uploads/tYcgpo9gfyKttKrKFsXuLo/ChatGPT_Image_Mar_21,_2026,_09_50_42_PM.png" alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-contain object-top pointer-events-none z-0" data-id="element-2089" data-mp="3gh2rw1j3e48r" />
      {/* Soft overlay for readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/60 to-white/80 z-0" data-id="element-2090" data-mp="2byywe908wt71" />

      {/* Hero */}
      <section className="relative py-20 text-center overflow-hidden bg-gradient-to-b from-blush-50/30 to-white/20 backdrop-blur-[1px]" data-id="element-2091" data-mp="2lv1u92o2e5o6">
        <SparkleEffect count={80} data-id="element-2092" data-mp="2zt8jjuey6xc8" />
        <div className="max-w-3xl mx-auto px-4 relative z-10" data-id="element-2093" data-mp="2zs6x6tsheof7">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="font-heading text-5xl md:text-6xl font-bold text-plum-800 mb-6 drop-shadow-sm" data-id="element-2094" data-mp="2uuov9ncvt9gp">
            Trippin' Through <span className="text-cta-600" data-id="element-2095" data-mp="3iiyeqimmhl4o">Healing</span>
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-plum-700 font-semibold" data-id="element-2096" data-mp="3el0pjfsuqz1a">
            Real-life guidance, mindset support, and confidence rebuilding—not
            therapy, but practical help navigating real-life challenges.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-lg text-cta-600 font-bold mt-4" data-id="element-2097" data-mp="877wdl8js4fw">
            Book your free call today
          </motion.p>
        </div>
      </section>

      {/* What to expect */}
      <section className="py-16 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2098" data-mp="2owdbcmxam8ir">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-2099" data-mp="2oy7z08zy8eqj">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-2100" data-mp="162k0j1r9xym7">
            <div className="aspect-square rounded-[3rem] bg-lavender-100/80 backdrop-blur-sm p-8 flex items-center justify-center relative overflow-hidden border border-lavender-200/60" data-id="element-2101" data-mp="s7redkgvpk6n">
              <SparkleEffect count={40} data-id="element-2102" data-mp="1kzazxb0y7abt" />
              <div className="text-center z-10" data-id="element-2103" data-mp="1fz6k7n7v6jmn">
                <FlameIcon className="w-16 h-16 text-cta-500 mx-auto mb-4" data-id="element-2104" data-mp="1fxviru1w5nyp" />
                <h3 className="font-heading text-3xl text-plum-800 font-bold" data-id="element-2105" data-mp="1azaglp32wu7m">
                  Who It's For
                </h3>
                <ul className="mt-6 space-y-3 text-left" data-id="element-2106" data-mp="4lkspvej85xy">
                  <li className="flex items-center gap-2 text-plum-800 font-semibold" data-id="element-2107" data-mp="3vqb4ohfzyfyt">
                    <SparklesIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-2108" data-mp="1nhct18wj7lc9" />{' '}
                    You're stuck and you know it.
                  </li>
                  <li className="flex items-center gap-2 text-plum-800 font-semibold" data-id="element-2109" data-mp="1sapg3elkbk2w">
                    <SparklesIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-2110" data-mp="1ej173k6m1bq5" />{' '}
                    You're tired of just surviving.
                  </li>
                  <li className="flex items-center gap-2 text-plum-800 font-semibold" data-id="element-2111" data-mp="275lwwg7ftfrl">
                    <SparklesIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-2112" data-mp="2b778ly88jo07" />{' '}
                    You need someone who won't judge your mess.
                  </li>
                  <li className="flex items-center gap-2 text-plum-800 font-semibold" data-id="element-2113" data-mp="1x9sewhay8u2f">
                    <SparklesIcon className="w-4 h-4 text-cta-500 shrink-0" data-id="element-2114" data-mp="224xyh9gvpwnc" />{' '}
                    You're ready to do the damn work.
                  </li>
                </ul>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white/85 backdrop-blur-sm rounded-3xl p-8 border border-blush-100 shadow-lg" data-id="element-2115" data-mp="j7ulvzunmkzz">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-plum-800 mb-6" data-id="element-2116" data-mp="n7vc0hr48kmv">
              What to Expect
            </h2>
            <ul className="space-y-6" data-id="element-2117" data-mp="3ropduk9wykza">
              {[{
              title: 'Real talk, not textbook advice',
              desc: "I don't do fluff. We're going to look at your life honestly and figure out exactly what needs to change."
            }, {
              title: 'Someone who actually gives a damn',
              desc: 'When you work with me, I am fully invested in your healing and your success.'
            }, {
              title: 'Accountability with love (and tough love)',
              desc: 'I will hold your hand, but I will also call you out on your excuses. Because you deserve better.'
            }, {
              title: 'Mindset shifts that stick',
              desc: "We aren't just putting a band-aid on it. We are rewiring how you think and operate."
            }].map((item, i) => <li key={i} className="flex gap-4" data-id="element-2118" data-mp="t09al9n4yop7" data-mpi={i}>
                  <div className="mt-1 w-2 h-2 rounded-full bg-cta-500 shrink-0" data-id="element-2119" data-mp="xy2f7y8sjand" />
                  <div data-id="element-2120" data-mp="12vuj7qmpmn7x">
                    <h4 className="font-bold text-plum-800 text-lg" data-id="element-2121" data-mp="12vb2gd8sq4vh">
                      {item.title}
                    </h4>
                    <p className="text-plum-600 font-semibold" data-id="element-2122" data-mp="16vl5pi57eh6n">{item.desc}</p>
                  </div>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </section>

      {/* What I Help With */}
      <section className="py-16 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-2123" data-mp="6q0wwhktunmd">
        <div className="text-center mb-12" data-id="element-2124" data-mp="2o5vze6t6c94">
          <h2 className="font-heading text-4xl font-bold text-plum-800 mb-4" data-id="element-2125" data-mp="2p771intqyqu">
            What I Help With
          </h2>
          <p className="text-plum-700 font-semibold max-w-2xl mx-auto text-lg" data-id="element-2126" data-mp="3u0h141koz7i7">
            Life coaching covers a lot of ground. Here are some of the areas I
            work with most — but honestly, if you are going through it, we can
            figure it out together.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2127" data-mp="3f7f7kkxk9g0r">
          {[{
          icon: '💼',
          title: 'Business & Side Hustles',
          items: ['Getting started', 'Organization and planning', 'Website building guidance', 'Turning ideas into action']
        }, {
          icon: '🏠',
          title: 'Jobs & Work From Home',
          items: ['Job search help', 'Resume guidance', 'Finding legitimate remote work', 'Tools and job platforms']
        }, {
          icon: '🧠',
          title: 'Life Organization & Mindset',
          items: ['Managing life chaos', 'Building simple routines', 'Stress management for busy lives', 'Consistency and motivation']
        }, {
          icon: '💪',
          title: 'Real-Life Support',
          items: ['Accountability', 'Breaking goals into steps', 'Overcoming overthinking', 'Practical guidance']
        }].map((category, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-br from-blush-50/60 to-lavender-50/40 backdrop-blur-sm rounded-3xl p-6 md:p-8 border border-blush-100/50 shadow-sm hover:shadow-md transition-shadow" data-id="element-2128" data-mp="1jvax7qqq9uwe" data-mpi={i}>
              <div className="flex items-center gap-3 mb-4" data-id="element-2129" data-mp="3i6kubgwcx73j">
                <span className="text-2xl" data-id="element-2130" data-mp="3i85o34aukm0c">{category.icon}</span>
                <h3 className="font-heading text-2xl font-bold text-plum-800" data-id="element-2131" data-mp="wcxqx9o8h2b">
                  {category.title}
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-2132" data-mp="22ore3rwkhdgm">
                {category.items.map((item, j) => <li key={j} className="flex items-start gap-2" data-id="element-2133" data-mp="1xq7s5rhz41o9" data-mpi={j}>
                    <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-cta-400 shrink-0" data-id="element-2134" data-mp="1xrsq7r3hy2qv" />
                    <span className="text-plum-700 font-semibold text-sm md:text-base" data-id="element-2135" data-mp="29bpk7rinw8f2">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </section>

      {/* How it works */}
      <section className="py-20 bg-blush-50/80 mt-12 relative z-10" data-id="element-2136" data-mp="1ueosho0h0dgl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2137" data-mp="2s15mokdwqay4">
          <h2 className="font-heading text-4xl font-bold text-plum-800 mb-16" data-id="element-2138" data-mp="2n22sxw3dnr5g">
            How It Works
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-2139" data-mp="2iaay39d6uz9i">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-blush-200" data-id="element-2140" data-mp="2dbgishefjsu5" />

            {[{
            icon: <CalendarIcon data-id="element-2141" data-mp="360nd146upw9l" />,
            title: '1. Book a Free Consultation Call',
            desc: "Your first consultation call is completely free. This is where we talk about what you're going through, what kind of support you need, and whether we're a good fit to work together. If you decide to continue after that, paid coaching options are available at the rates listed above."
          }, {
            icon: <MessageCircleIcon data-id="element-2142" data-mp="3sa40z228utu2" />,
            title: '2. Get Real',
            desc: 'We map out exactly where you are and where you want to be.'
          }, {
            icon: <SparklesIcon data-id="element-2143" data-mp="53beljygp7x4" />,
            title: '3. Transform',
            desc: 'We do the work. You stop surviving and start living like a badass.'
          }].map((step, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.2
          }} className="relative z-10" data-id="element-2144" data-mp="eto6xyciq5dt" data-mpi={i}>
                <div className="w-24 h-24 mx-auto bg-white rounded-full shadow-sm border border-blush-100 flex items-center justify-center text-cta-500 mb-6" data-id="element-2145" data-mp="8u9kwlxfzzeb">
                  {cloneElement(step.icon as React.ReactElement, {
                className: 'w-10 h-10'
              })}
                </div>
                <h3 className="font-heading text-2xl font-bold text-plum-800 mb-3" data-id="element-2146" data-mp="cutifqlxh50z">
                  {step.title}
                </h3>
                <p className="text-plum-700 font-semibold" data-id="element-2147" data-mp="rqsxjl7gg5fm">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-24 px-4 bg-white/80 relative overflow-hidden z-10" data-id="element-2148" data-mp="2tkigicc283jg">
        <SparkleEffect count={50} data-id="element-2149" data-mp="2omqgsw56bd4p" />
        <div className="max-w-6xl mx-auto relative z-10" data-id="element-2150" data-mp="2onia20basyrt">
          <div className="text-center mb-16" data-id="element-2151" data-mp="144g15diw057r">
            <h2 className="font-heading text-4xl font-bold text-plum-800 mb-4" data-id="element-2152" data-mp="1927ywo67qljv">
              Accessible pricing because everyone deserves support.
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-2153" data-mp="ub7erlw3t37w">
            {/* Card 1 */}
            <div className="bg-white/90 backdrop-blur-sm border border-blush-100 rounded-[3rem] p-10 shadow-xl flex flex-col relative overflow-hidden" data-id="element-2154" data-mp="za1zitdmt1un">
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-2" data-id="element-2155" data-mp="pf09zwfg1xrj">
                1:1 Session
              </h3>
              <p className="text-plum-600 font-semibold mb-6" data-id="element-2156" data-mp="bgk4g8tbidaz">45–60 minutes</p>
              <div className="mb-8" data-id="element-2157" data-mp="ge2fc4qwb2lm">
                <span className="font-heading text-4xl font-bold text-plum-800" data-id="element-2158" data-mp="25sh06dysm5bu">
                  $25–$45
                </span>
              </div>
              <p className="text-plum-700 font-semibold mb-10 flex-grow" data-id="element-2159" data-mp="2aq8qx4npbleg">
                A single deep-dive session to tackle what's on your mind right
                now.
              </p>
              <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-full bg-plum-700 text-white font-bold text-lg hover:bg-plum-800 transition-colors text-center block" data-id="element-2160" data-mp="5raeqrlpjt5n">
                Book Free Consultation
              </a>
            </div>

            {/* Card 2 (Most Popular) */}
            <div className="bg-gradient-to-br from-plum-900 to-plum-800 rounded-[3rem] p-10 shadow-2xl flex flex-col relative overflow-hidden transform md:-translate-y-4" data-id="element-2161" data-mp="3e60tu4l3bjsj">
              <div className="absolute top-0 right-0 w-32 h-32 bg-cta-500/20 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-2162" data-mp="3a6a6kaurvlsr" />
              <div className="inline-flex self-start px-4 py-1.5 rounded-full bg-cta-500 text-white text-xs font-bold uppercase tracking-wider mb-6" data-id="element-2163" data-mp="306jcgaa4j8t7">
                Most Popular
              </div>
              <h3 className="font-heading text-2xl font-bold text-white mb-2" data-id="element-2164" data-mp="1kn1wnha7btdy">
                3 Session Package
              </h3>
              <div className="mb-8 mt-6" data-id="element-2165" data-mp="1png693rgbbe3">
                <span className="font-heading text-4xl font-bold text-white" data-id="element-2166" data-mp="1pkaethvcnxf7">
                  $60–$100
                </span>
              </div>
              <p className="text-white/90 font-semibold mb-10 flex-grow" data-id="element-2167" data-mp="wyipj52w1mng">
                Three sessions to build momentum and create real, lasting
                change.
              </p>
              <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-600 transition-colors shadow-lg shadow-cta-500/30 text-center block" data-id="element-2168" data-mp="15xvyzxr0ib86">
                Book Free Consultation
              </a>
            </div>

            {/* Card 3 */}
            <div className="bg-white/90 backdrop-blur-sm border border-blush-100 rounded-[3rem] p-10 shadow-xl flex flex-col relative overflow-hidden" data-id="element-2169" data-mp="1lhe761x85rrm">
              <h3 className="font-heading text-2xl font-bold text-plum-800 mb-2" data-id="element-2170" data-mp="1v8inb4ymzio1">
                Monthly Support
              </h3>
              <div className="mb-8 mt-12" data-id="element-2171" data-mp="1qck19o0s6cqs">
                <span className="font-heading text-4xl font-bold text-plum-800" data-id="element-2172" data-mp="12kcz288djbjg">
                  $120–$180
                </span>
                <span className="text-plum-600 font-semibold" data-id="element-2173" data-mp="xncs7v3pa4ra">/month</span>
              </div>
              <p className="text-plum-700 font-semibold mb-10 flex-grow" data-id="element-2174" data-mp="1bmcfozfh8dlv">
                Ongoing support with weekly check-ins to keep you on track and
                thriving.
              </p>
              <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="w-full py-4 rounded-full bg-plum-700 text-white font-bold text-lg hover:bg-plum-800 transition-colors text-center block" data-id="element-2175" data-mp="2mzex1wpeh773">
                Book Free Consultation
              </a>
            </div>
          </div>

          <p className="text-center text-plum-700 font-semibold mt-10 max-w-2xl mx-auto" data-id="element-2176" data-mp="2gmki2d9prrrl">
            Your first consultation call is free. You'll receive a Google Meet
            link after booking.
            <br data-id="element-2177" data-mp="39b85aee0wr7s" />
            <br data-id="element-2178" data-mp="3e88c4rip5xzy" />
            All sessions are personalized to your needs. Once you submit your
            request, I'll reach out to schedule and confirm details.
          </p>
          <p className="text-center text-plum-500 text-sm font-medium mt-4 max-w-xl mx-auto italic" data-id="element-2179" data-mp="2zh971qh2lrl4">
            * Prices may vary. These are base coaching prices. Any additional
            services (e.g. building websites, custom projects) are charged
            separately.
          </p>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 text-center px-4 relative z-10" data-id="element-2180" data-mp="1wx01ht0snt13">
        <div className="max-w-2xl mx-auto bg-white/90 backdrop-blur-sm p-12 rounded-[3rem] shadow-xl border border-blush-100 relative overflow-hidden" data-id="element-2181" data-mp="1wyb3poelcsq3">
          <SparkleEffect count={50} data-id="element-2182" data-mp="1o57rtkjlgnxk" />
          <div className="relative z-10" data-id="element-2183" data-mp="1o225gd2co05j">
            <h2 className="font-heading text-3xl font-bold text-plum-800 mb-4" data-id="element-2184" data-mp="1j5ldf7s151n6">
              Ready to invest in yourself?
            </h2>
            <p className="text-plum-700 mb-8 font-semibold" data-id="element-2185" data-mp="2fustw1dskkk8">
              Real-life guidance, mindset support, and confidence rebuilding.
              Let's figure out the right fit for you.
            </p>
            <a href="https://calendly.com/trippinwithmandy/free-consultation-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-cta-500 text-white font-bold text-lg hover:bg-cta-600 transition-all shadow-lg hover:-translate-y-1" data-id="element-2186" data-mp="26stch7yv7egr">
              <GlitterHeart size={20} variant="light" data-id="element-2187" data-mp="ge0s68bjp472" />
              Book Free Consultation
            </a>
          </div>
        </div>
      </section>
    </div>;
}